import { Component, Input, OnInit, inject } from '@angular/core';
import {Location} from '@angular/common';

import {Languages, ModalService, ModalType} from '@shared';

import {MenuItem, MenuItems, MenuService} from '../menu';
import {CsatService, FeatureFlags, FeatureFlagService, SessionService} from '../services';
import {BreakpointObserverService, BreakpointValue} from "planner-shared";
import {Observable} from 'rxjs';
import {AttributionComponent} from "../attribution/attribution.component";
import {SurvicateService} from "../services/survicate/survicate.service";

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    standalone: false
})
export class NavbarComponent implements OnInit {
    private readonly csatService = inject(CsatService);
    private readonly sessionService = inject(SessionService);
    private readonly menuService = inject(MenuService);
    private readonly location = inject(Location);
    private readonly breakpointObserverService = inject(BreakpointObserverService);
    private readonly modalService = inject(ModalService);
    private readonly featureFlagService = inject(FeatureFlagService);
    private readonly survicateService = inject(SurvicateService);

    @Input() planName: string;
    public menuItem: MenuItem;
    public languages = Languages;
    public contextVisible: boolean;
    public zoomAmount = 100;
    public scaleAmount = 1;
    public showFeedbackButton: boolean;
    public currentBreakPoint: BreakpointValue;
    public zoomButtonFeatureEnabled: Observable<boolean>;
    public licenseAttributionFeatureEnabled: Observable<boolean>;
    protected readonly BreakpointValues = BreakpointValue;

    ngOnInit() {
        this.menuItem = this.menuService.getMenuItems(MenuItems)[0];
        setTimeout(() => {
            this.showFeedbackButton = this.location.path().indexOf('/route-planner/planner/') > -1;
        }, 1);

        this.breakpointObserverService
            .getCurrentBreakpoint()
            .subscribe(currentBreakpoint => {
                this.currentBreakPoint = currentBreakpoint;
            });
        this.zoomButtonFeatureEnabled = this.featureFlagService.isEnabled(FeatureFlags.ZoomButtons);
        this.licenseAttributionFeatureEnabled = this.featureFlagService.isEnabled(FeatureFlags.LicenseAttribution);
        this.survicateService.init();
    }

    public changeLanguage(language: Languages): void {
        this.contextVisible = false;
        this.sessionService.SetLanguage(language);
    }

    public enableCsatSection(): void {
        this.csatService.enableCsat(true);
    }

    public toggleContext(): void {
        this.contextVisible = !this.contextVisible;
    }

    public closeContext(): void {
        this.contextVisible = false;
    }

    public zoomIn(): void {
        if (this.scaleAmount <= 1.4) {
            this.scaleAmount += 0.1;
            this.zoomAmount += 10;
            document.body.style.zoom = String(this.scaleAmount);
        }
    }

    public zoomOut(): void {
        if (this.scaleAmount >= 0.7) {
            this.scaleAmount -= 0.1;
            this.zoomAmount -= 10;
            document.body.style.zoom = String(this.scaleAmount);
        }
    }

    public onPlanNameRightClick($event) {
        $event.preventDefault();
        this.modalService.openInformationModal(
            ModalType.OK,
            `Session id: ${this.sessionService.requestId}`,
            () => {}
        );
    }

    public openAttributionModal(): void {
        this.modalService.openCustomModal(
            AttributionComponent,
            () => {
            },
            () => {
            },
            null,
            true
        );
    }
}
